module.exports = __webpack_public_path__ + "img/tw.50eeda23.svg";